// extracted by mini-css-extract-plugin
export var breadcrumbs = "pageTitle-module--breadcrumbs--62Rtx";
export var title = "pageTitle-module--title--9UXBM";
export var titleContainer = "pageTitle-module--titleContainer--tRGWJ";